<template>
  <div>
    <v-layout class="mb-5" v-if="!internalView">
      <v-row>
        <v-col cols="6" sm="12" md="6">
          <v-hover v-slot:default="{ hover }">
            <v-card
              color="#363636"
              dark
              :elevation="hover ? 12 : 2"
              :class="{ 'on-hover': hover }"
            >
              <v-card-title class="headline">Contents</v-card-title>
              <v-card-subtitle>
                <p
                  class="pa-0 ma-0 custom-font"
                >Target : {{ campaignData.min_content }} to {{ campaignData.max_content }}</p>
                <p class="pa-0 ma-0 custom-font">Current Total: {{measurement.total}}</p>
                <p
                  class="pa-0 ma-0 custom-font"
                >Percentage: {{measurement.totalPercentage}}%</p>
              </v-card-subtitle>
            </v-card>
          </v-hover>
        </v-col>
        <v-col cols="6" sm="12" md="6">
          <v-hover v-slot:default="{ hover }">
            <v-card
              color="#363636"
              dark
              :elevation="hover ? 12 : 2"
              :class="{ 'on-hover': hover }"
            >
              <v-card-title class="headline">Outreach</v-card-title>
              <v-card-subtitle>
                <p
                  class="pa-0 ma-0 custom-font"
                >Target : {{ campaignData.outreach | thousandSeprator}}</p>
                <p
                  class="pa-0 ma-0 custom-font"
                >Current Total: {{measurement.outreach | thousandSeprator}}</p>
                <p
                  class="pa-0 ma-0 custom-font"
                >Percentage: {{measurement.outreachPercentage}}%</p>
              </v-card-subtitle>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-layout>
    <div class="text-right" v-if="internalView">
      <v-menu
        :close-on-content-click="false"
        bottom
        left
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            color="secondary"
            v-bind="attrs"
            v-on="on"
            @click="openColSettingsModal"
          >
            <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
          </v-btn>
        </template>
      </v-menu>
    </div>
    <v-data-table
      :headers="computedHeaders"
      :items="influencerItems"
      :items-per-page="itemsPerPage"
      item-key="id"
      class="pairing-elimination-table elevation-1"
    >
      <template v-slot:body="{items}">
        <tbody>
          <tr v-for="(item, index) in items" :key="item.name">
            <td v-bind:class="{'table-row-eliminated': isEliminated(item)}" v-if="displayFields('igHandle')">
              <!-- <a
                :href="'https://www.tiktok.com/@' + item.instagramHandle"
                target="_blank"
                v-if="item.platform === 'tiktok'"
              ><img src="/static/img/tiktok-32.png" width="20px" /> @{{item.instagramHandle}}</a>
              <a
                target="_blank"
                v-bind:href="'https://instagram.com/' + item.instagramHandle"
                v-else
              ><v-icon color="#000000" small>mdi-instagram</v-icon>  @{{ item.instagramHandle }}</a> -->
              <social-handle
                :isTikTok="item.platform === 'tiktok'"
                :isInstagram="item.platform === 'instagram'"
                :isYoutube="item.platform === 'youtube'"
                :isFacebook="item.platform === 'facebook'"
                :isXiaohongshu="item.platform === 'xiaohongshu'"
                :isLinkedIn="item.platform === 'linkedin'"
                :isTwitter="item.platform === 'twitter' || item.platform === 'x'"
                :isOthers="item.platform === 'others'"
                :tiktokHandle="item.instagramHandle"
                :instagramHandle="item.instagramHandle"
                :youtubeHandle="item.instagramHandle"
                :facebookHandle="item.instagramHandle"
                :linkedinHandle="item.linkedinHandle || item.userHandle || item.instagramHandle"
                :twitterHandle="item.twitterHandle || item.userHandle || item.instagramHandle"
                :otherHandle="item.instagramHandle"
                :xiaohongshuHandle="item.xhsID"
                :xiaohongshuFullName="item.fullName"
              />
            </td>
            <td v-if="displayFields('platformName')">{{ item.platformName | platformDisplayName }}</td>
            <td v-bind:class="{'table-row-eliminated': isEliminated(item)}" v-if="displayFields('totalFollowers')">
              <span v-if="item.followers">{{ item.followers | thousandSeprator }}</span>
            </td>
            <td align="center" v-if="displayFields('genderPercentage')">
              <div style="max-width:70px">
                <PieChart
                  :name="`genderPie${item.pairingID}`"
                  :title="genderPie.title"
                  :labels="genderPie.labels"
                  :backgroundColors="genderPie.backgroundColors"
                  :items="getGenderPieData(item.audience_genders)"
                  :options="genderPie.options"
                  :width="genderPie.width"
                  :height="genderPie.height"
                  v-if="item.audience_genders && item.audience_genders.length > 0"
                />
              </div>
            </td>
            <td v-if="displayFields('AudienceCredibility')">
              <v-icon :color="item.audience_credibility_color">supervised_user_circle</v-icon>
            </td>
            <td v-if="displayFields('engagementRate')">
              <span v-if="item.engagement_rate">{{ item.engagement_rate }} %</span>
              <span v-else>-</span>
            </td>
            <td v-if="displayFields('remarks')">{{item.remarks}}</td>
            <td v-if="displayFields('contentFeature')">{{item.contentFeature}}</td>
            <td align="center" v-if="displayFields('gender')">
              <v-chip
                :class="`ma-2 ${isEliminated(item) ? 'eliminate-text': ''}`"
                color="#ffffff"
                small
                text-color="black"
                style="text-transform: capitalize;"
              >{{item.gender || '-'}}</v-chip>
            </td>
            <td align="center" v-if="displayFields('age_group')">
              <v-chip
                :class="`ma-2 ${isEliminated(item) ? 'eliminate-text': ''}`"
                color="#ffffff"
                small
                text-color="black"
                style="text-transform: capitalize;"
              >{{item.age_group || '-'}}</v-chip>
            </td>
            <td align="center" v-if="displayFields('aud_age_group')">
              <div class="d-flex">
                <div
                  class="ml-2"
                  v-for="(audAge, index) in item.topAudAges"
                  :key="index">                                    
                    <v-chip
                      x-small
                    >{{audAge.code}}</v-chip>
                </div>
                <!-- <v-menu
                  v-if="item.topAudAges.length"
                  :close-on-content-click="false"
                  top                                                 
                  offset-x                              
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="multi-select-more-btn"
                      :id="'btnMore_'+item.pairingID"
                      v-show="item.topAudAges.length"  
                      small
                      dark
                      v-bind="attrs"
                      v-on="on"
                      text
                    >
                      <span v-if="item.topAudAges && item.topAudAges.length">
                        {{item.topAudAges ? item.topAudAges[0].code : '-'}}
                      </span>
                    </v-btn>
                  </template>
                  <v-card max-width="300" style="text-align: left;">
                    <v-card-text>
                      <div>Aud. Age Group (Majority)</div>
                      <div v-if="item.topAudAges">
                        <v-divider></v-divider>
                        <div
                        class="d-flex justify-space-between"
                        v-for="(audAge, index) in item.topAudAges"
                        :key="index">                                    
                          <v-chip
                            class="ma-2"
                            x-small
                          >{{audAge.code}}</v-chip>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-menu> -->
              </div>
            </td>
            <td align="center" v-if="displayFields('country')">
              <div class="d-flex">
                <div
                class="ml-2"
                v-for="(country, index) in item.topCountries"
                :key="index">                                    
                  <v-chip
                    x-small
                  >{{country.name}}</v-chip>
                </div>
                <!-- <v-menu
                  v-if="item.topCountries.length"
                  :close-on-content-click="false"
                  top                                                 
                  offset-x                              
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="multi-select-more-btn"
                      :id="'btnMore_'+item.pairingID"
                      v-show="item.topCountries.length" 
                      small
                      dark
                      v-bind="attrs"
                      v-on="on"
                      text
                    >
                      <span v-if="item.topCountries && item.topCountries.length">
                        {{item.topCountries ? item.topCountries[0].name : '-'}}
                      </span>
                    </v-btn>
                  </template>
                  <v-card max-width="300" style="text-align: left;">
                    <v-card-text>
                      <div>Aud. Country (Majority)</div>
                      <div v-if="item.topCountries">
                        <v-divider></v-divider>
                        <div
                        class="d-flex justify-space-between"
                        v-for="(country, index) in item.topCountries"
                        :key="index">                                    
                          <v-chip
                            class="ma-2"
                            x-small
                          >{{country.name}}</v-chip>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-menu> -->
              </div>
            </td>
            <!-- <td v-bind:class="{'table-row-eliminated': !item.selected}">{{ item.instagramFullname }}</td> -->
            <td v-if="elimination && displayFields('selected')">
              <v-menu offset-y :disabled="disableActions || item.eliminationStatus !== eliminationStatus.PENDING || item.payoutDetails.status === payoutStatus.CONFIRMED">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn :class="disableActions || item.eliminationStatus !== eliminationStatus.PENDING || item.payoutDetails.status === payoutStatus.CONFIRMED ? 'v-btn--disabled v-btn--has-bg' : ''" :color="getSelectAttributes(item, 'color')" dense :dark="disableActions || item.eliminationStatus !== eliminationStatus.PENDING || item.payoutDetails.status === payoutStatus.CONFIRMED ? false : true" v-bind="attrs" v-on="on">
                    <v-icon left>
                      {{getSelectAttributes(item, 'icon')}}
                    </v-icon> {{getSelectAttributes(item, 'text')}}
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(action, actionIndex) in getSelectAttributes(item, 'menus')"
                    :key="actionIndex"
                    @click="actionHandler(item.pairingID, action.title)"
                  >
                    <v-list-item-title><v-icon left>
                      {{getIconByTitle(action.title)}}
                    </v-icon> {{ action.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <!-- <v-tooltip top v-if="item.eliminationStatus === eliminationStatus.SELECTED">
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="green"
                    v-on="on"
                    small
                    @click="actionHandler(index, item.pairingID, item.eliminationStatus)"
                  >
                    {{showEliminationStatus(item.eliminationStatus)}}
                    <v-icon right>mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>Click to Eliminate</span>
              </v-tooltip>
              <v-tooltip top v-else-if="item.eliminationStatus === eliminationStatus.ELIMINATED">
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="red"
                    v-on="on"
                    small
                    @click="actionHandler(index, item.pairingID, item.eliminationStatus)"
                  >
                    {{showEliminationStatus(item.eliminationStatus)}}
                    <v-icon right>mdi-cancel</v-icon>
                  </v-btn>
                </template>
                <span>Click to Select</span>
              </v-tooltip>
              <v-tooltip top v-else-if="item.eliminationStatus === eliminationStatus.PENDING">
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="secondary"
                    v-on="on"
                    small
                    @click="actionHandler(index, item.pairingID, item.eliminationStatus)"
                  >
                    {{showEliminationStatus(item.eliminationStatus)}}
                    <v-icon right>mdi-new-box</v-icon>
                  </v-btn>
                </template>
                <span>Click to Select</span>
              </v-tooltip> -->
            </td>
            <td v-if="displayFields('eliminatedReason')">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn small v-on="on" v-show="isEliminated(item)" @click.stop="viewReason(item)">
                    <v-icon small>mdi-file-document-box</v-icon>
                  </v-btn>
                </template>
                <span>View Reason</span>
              </v-tooltip>
            </td>
            <td v-if="displayFields('notes')">
              <v-tooltip top v-if="!isClientRole && item.clientNotes.length">
                <template v-slot:activator="{ on }">
                  <v-btn small color="warning" v-on="on" @click.stop="openClientNotesDialog(item)">
                    <v-icon small>mdi-file-document-box</v-icon>
                  </v-btn>
                </template>
                <span>View Note</span>
              </v-tooltip>
              <v-badge
                @click.stop="openClientNotesDialog(item)"
                :value="getClientUnreadCount(item)"
                :content="getClientUnreadCount(item)"
                color="green"
                overlap
                v-if="isClientRole"
              >
                <v-btn
                @click.stop="openClientNotesDialog(item)"
                color="warning"
                small>
                  <v-icon small>edit</v-icon> Add Note ({{item.clientNotes ? item.clientNotes.length : 0}})
                </v-btn>
              </v-badge>
            </td>
            <td v-if="!elimination && displayFields('selected')">
              {{showEliminationStatus(item.eliminationStatus)}}
              <v-icon
                right
                :color="isSelected(item) ? 'green' : 'red'"
              >{{isSelected(item) ? 'check' : 'cancel'}}</v-icon>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <div class="text-right pt-2" v-if="elimination && !internalView">
      <v-btn outlined color="secondary" :disabled="disableActions" @click="saveEliminationChanges('accept')">Accept All</v-btn>
      <v-btn outlined color="secondary" :disabled="disableActions" @click="saveEliminationChanges('save_draft')">Save as Draft</v-btn>
      <v-btn color="primary" :disabled="disableActions" @click="saveEliminationChanges('save')">Save and Submit</v-btn>
    </div>
    <div class="pairing-elimination-actions text-right pt-2" v-if="internalView">
      <v-btn text color="secondary" @click="closeElimination">Close</v-btn>
      <v-btn color="secondary" @click="confirmSendToClient()">Confirm</v-btn>
    </div>
    <v-dialog persistent v-model="reasonDialog" max-width="480">
      <v-card>
        <v-card-title>
          Share with us why this influencer is eliminated
          <span>(note to avoid subjective bias)</span>
        </v-card-title>
        <v-card-text>
          <v-textarea v-model="eliminatedReason" filled auto-grow></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="secondary" @click="cancelReason">Cancel</v-btn>
          <v-btn text color="secondary" @click="saveReason">Done</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="viewReasonDialog" max-width="350">
      <v-card>
        <v-card-title>
          Remarks for&nbsp;
          <a
            target="_blank"
            v-bind:href="'https://instagram.com/' + viewReasonData.igHandle"
          >@{{ viewReasonData.igHandle }}</a>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <p class="body-1">{{viewReasonData.text}}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="viewReasonDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Client Notes Dialog -->
    <client-notes-modal  v-model="clientNotesDialog" :value="clientNotesDialog" :data="clientNotesData" @savedNotes="refreshPairingData"/>
    <!-- table cols show hide dialog -->
    <table-cols-show-hide-modal
      v-model="colSettingsDialog"
      title="Client Elimination Columns"
      :items="tableColsItems"
      @updated="updateTableCols"
    />
    <!-- end of table cols show hide dialog -->
  </div>
</template>
<script>
import ClientNotesModal from '../Campaign/PairingInfluencer/ClientNotesModal';
import pairingAPIs from './pairingAPIs';
import campaignConfig from '../Campaign/config';
import SocialHandle from '../../scoped/custom/SocialHandle'
import config from '@/config';
import utils from '../../../utils'
import PieChart from '@/components/chartjs/Pie';
import TableColsShowHideModal from '@/components/scoped/custom/TableColsShowHideModal'
export default {
  components: { ClientNotesModal, SocialHandle, PieChart, TableColsShowHideModal },
  props: {
    influencers: Array,
    elimination: Boolean,
    internalView: Boolean,
    campaignID: String,
    campaignData: Object
  },
  data() {
    return {
      pairingStatus: campaignConfig.pairingStatus,
      eliminationStatus: campaignConfig.eliminationStatus,
      payoutStatus: campaignConfig.payoutStatus,
      changesDetected: false,
      viewReasonData: {},
      viewReasonDialog: false,
      clientNotesDialog: false,
      reasonDialog: false,
      workingIndex: null,
      workingID: null,
      eliminatedReason: '',
      limitReach: false,
      eliminatedPairings: [],
      selectedPairings: [],
      newPairings: [],
      eliminatedCount: 0,
      selectedCount: 0,
      newCount: 0,
      itemsPerPage: 30,
      influencerItems: [],
      headers: [
        { text: 'Influencer', value: 'igHandle', sortable: false },
        { text: 'Platform', value: 'platformName', sortable: false },
        { text: 'Followers', value: 'totalFollowers', sortable: false },
        { text: 'Aud. Gender', value: 'genderPercentage', sortable: false },
        { text: 'Credibility', value: 'AudienceCredibility', sortable: false },
        { text: 'Engagement', value: 'engagementRate', sortable: false },
        { text: 'Remarks', value: 'remarks', sortable: false },
        { text: 'Content Feature/pillar', value: 'contentFeature', sortable: false },
        { text: 'Gender', value: 'gender', sortable: false },
        { text: 'Age Group', value: 'age_group', sortable: false },
        { text: 'Aud. Age Group (Majority)', value: 'aud_age_group', sortable: false },
        { text: 'Aud. Country (Majority)', value: 'country', sortable: false },
        { text: 'Status', value: 'selected', sortable: false },
        { text: 'Eliminated Reason', value: 'eliminatedReason', sortable: false },
        { text: 'Internal Notes', value: 'notes', sortable: false }
      ],
      defaultOffCols: [
        'genderPercentage',
        'aud_age_group',
        'country'
      ],
      measurement: {
        total: 0,
        outreach: 0,
        outreachPercentage: '',
        totalPercentage: ''
      },
      campaign: {},
      genderPie: {
        title: '',
        labels: ['MALE', 'FEMALE'],
        backgroundColors: ['rgba(66, 165, 244, 1)', 'rgba(239, 83, 80, 1)'],
        options: {
          responsive: true,
          legend: false,
          tooltips: {
            bodyFontSize: 8,
            position: 'average',
            xAlign: 'center',
            yAlign: 'center',
            callbacks: {
              label: function(tooltipItem, data) {
                let label = data.labels[tooltipItem.index] || '';
                return label
              }
            }
          }
        },
        width: 70,
        height: 70
      },
      colSettingsDialog: false,
      colStatuses: {
        'igHandle': false,
        'platformName': false,
        'totalFollowers': false,
        'genderPercentage': false,
        'AudienceCredibility': false,
        'engagementRate': false,
        'remarks': false,
        'gender': false,
        'age_group': false,
        'aud_age_group': false,
        'country': false,
        'selected': false,
        'eliminatedReason': false,
        'notes': false,
        'contentFeature': false
      },
      tableColsItems: [],
      optionVal: 0
    };
  },
  async mounted() {
    // impl
  },
  methods: {
    displayFields(field) {
      if (this.colStatuses[field]) {
        return true
      }
      return false
    },
    calculateSummary() {
      this.measurement.total = this.measurement.outreach = 0;
      this.influencerItems.forEach(item => {
        if (item.eliminationStatus !== this.eliminationStatus.ELIMINATED) {
          // If influencer isn't eliminated
          this.measurement.total += Number(this.calculateContents(item));
          this.measurement.outreach += Number(this.calculateOutreach(item));
        }
      });
      this.measurement.outreachPercentage = ((this.measurement.outreach / this.campaign.outreach) * 100).toFixed(2);
      let content = (this.measurement.total / (this.campaign.min_content || this.campaign.min_influencer || 1)) * 100;
      this.measurement.totalPercentage = content > 100 ? 100 : Number(content).toFixed(2);
    },
    calculateContents(item) {
      return item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_tiktok_posts + item.no_of_reels;
    },
    calculateOutreach(item) {
      const followers = item.followers;
      return followers * (item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_tiktok_posts + item.no_of_reels);
    },
    updateCountStatus() {
      var countUnselect = 0;
      var countSelect = 0;
      var countPending = 0;
      this.influencerItems.forEach(element => {
        if (element.eliminationStatus === this.eliminationStatus.ELIMINATED) countUnselect++;
        else if (element.eliminationStatus === this.eliminationStatus.SELECTED) countSelect++;
        else if (element.eliminationStatus === this.eliminationStatus.PENDING) countPending++;
      });
      this.eliminatedCount = countUnselect;
      this.selectedCount = countSelect;
      this.newCount = countPending;
    },
    isEliminated(item) {
      return item.eliminationStatus === this.eliminationStatus.ELIMINATED;
    },
    isNew(item) {
      return item.eliminationStatus === this.eliminationStatus.PENDING;
    },
    isSelected(item) {
      return item.eliminationStatus === this.eliminationStatus.SELECTED;
    },
    closeElimination() {
      if (this.changesDetected) {
        this.$swal({
          title: 'You have unsaved changes, are you sure to close?',
          type: 'info',
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          showLoaderOnConfirm: true,
          preConfirm: reset => {
            this.resetWorkingData();
            this.changesDetected = false;
          },
          allowOutsideClick: () => !this.$swal.isLoading()
        }).then(result => {
          if (result.value) {
            this.$emit('savedEliminationChanges');
          }
        });
      } else {
        this.$emit('savedEliminationChanges');
      }
    },
    viewReason(influencer) {
      this.viewReasonData.igHandle = influencer.instagramHandle;
      this.viewReasonData.text = influencer.eliminatedReason || influencer.eliminationReason;
      this.viewReasonDialog = true;
    },
    cancelReason() {
      this.reasonDialog = false;
      this.resetWorkingData();
    },
    resetWorkingData() {
      this.workingID = this.workingIndex = null;
      this.eliminatedReason = '';
    },
    doEliminate(index, id, eliminatedData) {
      this.eliminatedPairings.push(eliminatedData);
      this.influencerItems[index].eliminationStatus = this.eliminationStatus.ELIMINATED;
      this.influencerItems[index].eliminatedReason = this.eliminatedReason;
      this.changesDetected = true;
      this.updateCountStatus();
      this.calculateSummary();
      this.resetWorkingData();
    },
    doSelect(index, id, statusTitle) {
      var newEliminationData = this.eliminatedPairings.filter(element => element.pairingID !== id);
      this.eliminatedPairings = newEliminationData;
      if (statusTitle === 'New') {
        this.influencerItems[index].eliminationStatus = this.eliminationStatus.PENDING;
      } else if (statusTitle === 'Selected') {
        this.influencerItems[index].eliminationStatus = this.eliminationStatus.SELECTED;
      }
      this.influencerItems[index].eliminatedReason = '';
      this.changesDetected = true;
      this.updateCountStatus();
      this.calculateSummary();
      this.resetWorkingData();
    },
    actionHandler(pairingID, statusTitle) {
      this.workingIndex = this.influencerItems.findIndex(i => i.pairingID === pairingID);
      this.workingID = pairingID;
      if (statusTitle === 'Eliminated') {
        // eliminating
        if (this.eliminatedCount < this.allowedAmount) {
          this.reasonDialog = true; // continue from reasonDialog
        } else {
          this.$swal({
            title: 'You have exceeded the maximum elimination limit.',
            text: 'Reselect the influencers if you want to continue.',
            type: 'warning'
          });
        }
      } else {
        this.doSelect(this.workingIndex, this.workingID, statusTitle); // selecting
      }
    },
    saveReason() {
      if (this.eliminatedReason === '') {
        this.$swal({
          title: 'Reason is required',
          type: 'error'
        });
      } else {
        var eliminatedObj = {
          pairingID: this.workingID,
          eliminatedReason: this.eliminatedReason
        };
        this.doEliminate(this.workingIndex, this.workingID, eliminatedObj);
        this.reasonDialog = false;
      }
    },
    saveEliminationChanges(action) {
      if (this.currentUserRole === config.userRoles.CLIENT ||
      this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH ||
      this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW) {
        this.selectedPairings = [];
        this.newPairings = []
        var selectedlist = []
        var newList = []
        var showSelectedCount = 0
        if (action === 'save' || action === 'save_draft') {
          selectedlist = this.influencerItems.filter(item => item.eliminationStatus === this.eliminationStatus.SELECTED);
          newList = this.influencerItems.filter(item => item.eliminationStatus === this.eliminationStatus.PENDING);
          newList.forEach(item => this.newPairings.push(item.pairingID))
          showSelectedCount = this.selectedCount
        } else {
          selectedlist = this.influencerItems.filter(item => item.eliminationStatus !== this.eliminationStatus.ELIMINATED);
          showSelectedCount = this.selectedCount + this.newCount
        }
        selectedlist.forEach(item => this.selectedPairings.push(item.pairingID));
        if (this.eliminatedPairings.length > 0 || this.selectedPairings.length > 0 || this.newPairings.length > 0) {
          let eliminationData = Object.assign(
            {},
            {
              campaignID: this.campaignID,
              eliminated: this.eliminatedPairings,
              selected: this.selectedPairings,
              new: this.newPairings
            }
          );
          if (action === 'save_draft') {
            eliminationData.action = action
            pairingAPIs
              .submitEliminatedInfluencers(eliminationData)
              .then(response => {
                this.$swal({
                  title: 'Success',
                  text: 'Your lineup is saved as draft, it has not been released to KOBE',
                  type: 'success'
                });
                this.changesDetected = false;
                this.$emit('savedEliminationChanges');
              })
              .catch(error => {
                console.log(error);
                this.$swal.showValidationError('Error in saving changes! Pleae try again.');
              });
          } else {
            let unselectedTxt = ''
            if (action === 'save') {
              unselectedTxt = `<li style='list-style:none'><strong>${this.newCount}</strong> creators unselected/new</li>`
            }
            this.$swal({
              html: `
                <div style='font-weight:600;text-align:left'>
                <p>
                  Upon Confirmation, the following will be submitted. <br>
                  <ul>
                    <li style='list-style:none'><strong>${showSelectedCount}</strong> creators approved</li>
                    ${unselectedTxt}
                    <li style='list-style:none'><strong>${this.eliminatedCount}</strong> creators eliminated</li>
                  </ul>
                  </p>
                  <p>
                  </div>
                `,
              type: 'info',
              icon: 'swal2-icon-hide',
              showCancelButton: true,
              showCloseButton: true,
              confirmButtonText: 'Submit',
              cancelButtonText: 'Cancel',
              showLoaderOnConfirm: true,
              preConfirm: callAPI => {
                return pairingAPIs
                  .submitEliminatedInfluencers(eliminationData)
                  .then(response => {
                    return response;
                  })
                  .catch(error => {
                    console.log(error);
                    this.$swal.showValidationError('Error in saving changes! Pleae try again.');
                  });
              },
              allowOutsideClick: () => !this.$swal.isLoading()
            }).then(result => {
              if (result.value) {
                this.$swal({
                  title: 'Success',
                  text: 'Your changes are successfully saved',
                  type: 'success'
                });
                this.changesDetected = false;
                this.$emit('savedEliminationChanges');
                // Create New infuencer object to mutate data for email template
                let influencerListForEmail = Object.assign({}, this.influencerItems);
                Object.keys(influencerListForEmail).forEach(influencer => {
                  if (influencerListForEmail[influencer].eliminationStatus === 2) {
                    influencerListForEmail[influencer].eliminationStatus = 'Rejected'
                    influencerListForEmail[influencer].color = 'red'
                  } else if (influencerListForEmail[influencer].eliminationStatus === 1) {
                    influencerListForEmail[influencer].eliminationStatus = 'Approved'
                    influencerListForEmail[influencer].color = 'green'
                    influencerListForEmail[influencer].eliminationReason = ''
                  } else {
                    influencerListForEmail[influencer].eliminationStatus = 'Pending'
                    influencerListForEmail[influencer].color = 'grey'
                    influencerListForEmail[influencer].eliminationReason = ''
                  }
                })
                const influencerListArray = Object.values(influencerListForEmail);
                // Add Send client accepted influencer Email notification here to CO or AM from campaign
                const protocol = window.location.protocol;
                const host = window.location.host;
                let emailParam = {
                  influencerList: influencerListArray,
                  campaignID: this.campaignID,
                  pairing_influencer_url: protocol + '//' + host + '/campaigns/pairing_influencer'
                }
                pairingAPIs.sendClientAcceptedInfluencerListEmailNotify(emailParam)
              }
            });
          }
        }
      } else {
        this.$swal({
          title: 'Permissions Required',
          text: `You don't have enough permissions to do this action.`,
          type: 'info'
        });
      }
    },
    toPercent(num) {
      return (num * 100).toFixed(2);
    },
    showEliminationStatus(status) {
      if (status === this.eliminationStatus.SELECTED) {
        return 'Selected';
      } else if (status === this.eliminationStatus.ELIMINATED) {
        return 'Eliminated';
      } else {
        return 'New';
      }
    },
    openClientNotesDialog(item) {
      this.clientNotesData = item
      this.clientNotesDialog = true
      if (this.isClientRole) {
        this.markNotesAsRead(item)
      }
    },
    refreshPairingData() {
      this.$emit('savedClientNotes')
    },
    getSelectAttributes: function(item, type) {
      if (item.eliminationStatus === this.eliminationStatus.NEW || item.eliminationStatus === this.eliminationStatus.PENDING) {
        if (type === 'color') {
          return 'primary'
        } else if (type === 'icon') {
          return 'mdi-new-box'
        } else if (type === 'text') {
          return 'New'
        } else if (type === 'menus') {
          return this.getBtnTitleLists(['Selected', 'Eliminated'])
        }
      } else if (item.eliminationStatus === this.eliminationStatus.SELECTED) {
        if (type === 'color') {
          return 'green'
        } else if (type === 'icon') {
          return 'mdi-check'
        } else if (type === 'text') {
          return 'Selected'
        } else if (type === 'menus') {
          return this.getBtnTitleLists(['New', 'Eliminated'])
        }
      } else if (item.eliminationStatus === this.eliminationStatus.ELIMINATED) {
        if (type === 'color') {
          return 'red'
        } else if (type === 'icon') {
          return 'mdi-cancel'
        } else if (type === 'text') {
          return 'Eliminated'
        } else if (type === 'menus') {
          return this.getBtnTitleLists(['New', 'Selected'])
        }
      }
    },
    getBtnTitleLists: function(titles) {
      let results = []
      for (let title of titles) {
        results.push({title})
      }
      return results
    },
    getIconByTitle(title) {
      if (title === 'New') {
        return 'mdi-new-box'
      } else if (title === 'Selected') {
        return 'mdi-check'
      } else if (title === 'Eliminated') {
        return 'mdi-cancel'
      }
    },
    getClientUnreadCount(item) {
      let unread = 0
      if (item.clientNotes !== undefined) {
        item.clientNotes.map(note => {
          note.read = note.read || []
          if (!note.read.includes(this.currentUserID)) {
            unread++
          }
        })
      }
      return unread
    },
    markNotesAsRead(item) {
      let unreadNoteIDs = []
      if (item.clientNotes !== undefined) {
        for (let note of item.clientNotes) {
          note.read = note.read || []
          if (!note.read.includes(this.currentUserID)) {
            unreadNoteIDs.push(this.currentUserID)
            note.read.push(this.currentUserID)
            this.updateReadNote(item.pairingID, unreadNoteIDs)
          }
        }
      }
      item.clientNotes = utils.func.refreshJSON(item.clientNotes)
    },
    updateReadNote(pairingID, unreadNoteIDs) {
      let formData = new FormData();
      formData.append('pairingID', pairingID);
      formData.append('unreads', unreadNoteIDs);
      pairingAPIs
        .saveClientNoteRead(formData)
        .then((response) => {
        })
        .catch(error => {
          console.log(error);
        });
    },
    getGenderPieData(audienceGenders) {
      if (Array.isArray(audienceGenders)) {
        let ret = []
        let male = audienceGenders.find(a => a.code === 'MALE')
        if (male) ret.push(male)
        let female = audienceGenders.find(a => a.code === 'FEMALE')
        if (female) ret.push(female)
        return ret.map(gender => (gender.weight * 100).toFixed(2))
      }
    },
    confirmSendToClient() {
      this.$emit('sendToClient')
    },
    openColSettingsModal() {
      this.tableColsItems = []
      let tmpStatuses = {}
      if (Object.keys(this.colStatuses).length) {
        tmpStatuses = Object.assign({}, this.colStatuses)
      } else {
        this.headers.map(header => {
          tmpStatuses[header.value] = true
        })
      }
      // eslint-disable-next-line
      for (const [key, value] of Object.entries(this.headers)) {
        if (value.text) {
          this.tableColsItems.push({
            title: value.text,
            key: value.value,
            value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
          })
        }
      }
      this.colSettingsDialog = true
    },
    async updateTableCols(items) {
      let columns = this.colStatuses
      items.map(item => {
        columns[item.key] = item.value
      })
      let tableSettings = {}
      if (this.campaign.tableSettings) {
        tableSettings = this.campaign.tableSettings
      }
      tableSettings.pairingEliminationCols = Object.assign({}, columns)
      let updateData = [{
        id: this.campaign.id,
        tableSettings
      }]
      await this.$store.dispatch('campaign/updateCampaignByIds', updateData)
      this.campaign.tableSettings = Object.assign({}, tableSettings)
      this.colStatuses = Object.assign({}, columns)
      this.colSettingsDialog = false
    }
  },
  computed: {
    // computedHeaders() {
    //   return this.headers.filter(h => {
    //     if (!this.isClientRole && h.value === 'notes') {
    //       return false
    //     }
    //     return true
    //   });
    // },
    computedHeaders() {
      let pairingEliminationCols = null
      // set col statuses from user table
      if (this.campaign.tableSettings) {
        if (this.campaign.tableSettings.pairingEliminationCols) {
          pairingEliminationCols = Object.assign({}, this.campaign.tableSettings.pairingEliminationCols)
        }
      }
      this.headers.map(header => {
        if (!this.colStatuses[header.value]) {
          if (this.defaultOffCols.includes(header.value)) {
            this.colStatuses[header.value] = false
          } else {
            this.colStatuses[header.value] = true
          }
        } else {
          this.colStatuses[header.value] = true
        }
      })
      if (pairingEliminationCols) {
        for (var key of Object.keys(pairingEliminationCols)) {
          this.colStatuses[key] = pairingEliminationCols[key]
        }
      }
      return this.headers.filter(h => {
        if (this.colStatuses[h.value]) {
          return true
        }
        return false
      })
    },
    currentUserID: function() {
      return this.$store.state.user.id;
    },
    currentUserRole: function () {
      return Number(this.$store.state.user.role);
    },
    isClientRole: function () {
      // for client role only
      return Number(this.$store.state.user.role) === config.userRoles.CLIENT;
    },
    isElimination: function() {
      return this.elimination || false;
    },
    allowedAmount: function() {
      return this.influencers.length * 0.1;
    },
    campaignStatusConfig: function() {
      return config.campaignStatus;
    },
    disableActions: function() {
      return this.campaignData.status === this.campaignStatusConfig.COMPLETE || this.internalView
    }
  },
  watch: {
    influencers: function(newList) {
      this.influencerItems = newList;
      this.selectedPairings = [];
      this.eliminatedPairings = [];
      this.campaign = Object.assign({}, this.campaignData)
      this.updateCountStatus();
      this.calculateSummary();
    },
    campaignData: function(newCampaign) {
      this.campaign = Object.assign({}, newCampaign)
      // Reset selectedInfluencers
      this.measurement = {
        total: 0,
        outreach: 0,
        outreachPercentage: '',
        totalPercentage: ''
      };
    }
  }
};
</script>
<style>
.table-row-eliminated,
.eliminate-text {
  text-decoration: line-through!important;
}
.pairing-elimination-table .multi-select-more-btn {
  background-color: #fff;
  color: #3f3f3f!important;
  font-size: 11px!important;
}
.pairing-elimination-table .multi-select-more-btn:hover {
  background: none;
  color: #3F3FFF!important;
  transition: 0.5s;
}
.pairing-elimination-actions {
  position: sticky;
  bottom: 0;
  z-index: 3;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
  padding: 12px 0 4px;
  background: #fff;
  border-top: 1px solid #dedede;
}
</style>



// WEBPACK FOOTER //
// PairingDataTable.vue?8c6e4788